import posthog from 'posthog-js';

import type { AnalyticsEventProperties, AnalyticsProvider } from '../types';

function isEnabled() {
  return Boolean(process.env.NEXT_PUBLIC_POSTHOG_PROJECT_TOKEN);
}

export const posthogAnalyticsProvider: AnalyticsProvider = {
  name: 'posthog',

  init() {
    if (!isEnabled()) {
      return;
    }

    posthog.init(process.env.NEXT_PUBLIC_POSTHOG_PROJECT_TOKEN!, {
      api_host: process.env.NEXT_PUBLIC_POSTHOG_HOST,
      ui_host: 'https://eu.posthog.com',
      defaults: '2026-01-30',
      capture_exceptions: true,
      debug: process.env.NODE_ENV === 'development',
    });
  },

  trackEvent(event, properties) {
    if (!isEnabled()) return;
    posthog.capture(event, properties);
  },

  identifyUser(distinctId, traits) {
    if (!isEnabled()) return;
    posthog.identify(distinctId, traits);
  },

  setGroup(groupType, groupId, properties) {
    if (!isEnabled()) return;
    posthog.group(groupType, groupId, properties);
  },

  resetSession() {
    if (!isEnabled()) return;
    posthog.reset();
  },

  captureException(error, context) {
    if (!isEnabled()) return;
    posthog.captureException(error, context);
  },
};
